class ProductStory extends HTMLElement {
  connectedCallback() {
    this.text = this.querySelector('[data-story-text]');
    this.toggle = this.querySelector('[data-story-toggle]');
    if (!this.text || !this.toggle) return;

    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.mobile = matchMedia('(max-width: 749px)');
    this.expanded = false;
    this.toggle.addEventListener('click', () => {
      this.expanded = !this.expanded;
      this.update();
      if (!this.expanded) {
        const rect = this.toggle.getBoundingClientRect();
        const header = document.querySelector('header-component');
        const top = Math.max(0, header?.getBoundingClientRect().bottom || 0);
        if (rect.top < top || rect.bottom > innerHeight) {
          this.toggle.scrollIntoView({ block: 'center', behavior: 'instant' });
        }
      }
    }, options);
    // Reveal any clipped rich-text link when reached using the keyboard.
    this.text.addEventListener('focusin', () => {
      if (this.hasAttribute('collapsed')) {
        this.expanded = true;
        this.update();
      }
    }, options);
    this.mobile.addEventListener('change', () => this.update(), options);
    this.observer = new ResizeObserver(() => this.update());
    this.observer.observe(this.text);
    this.update();
    document.fonts.ready.then(() => {
      if (this.isConnected) this.update();
    });
  }

  update() {
    const limit = parseFloat(getComputedStyle(this.text).lineHeight) * 10;
    if (!Number.isFinite(limit)) return;
    this.style.setProperty('--story-preview-height', `${limit}px`);
    const overflowing = this.mobile.matches && this.text.scrollHeight > limit + 1;
    this.toggle.hidden = !overflowing;
    this.toggle.setAttribute('aria-expanded', String(!overflowing || this.expanded));
    this.toggle.textContent = this.expanded ? this.toggle.dataset.less : this.toggle.dataset.more;
    this.toggleAttribute('collapsed', overflowing && !this.expanded);
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    this.removeAttribute('collapsed');
    if (this.toggle) this.toggle.hidden = true;
  }
}

if (!customElements.get('bm-product-story')) {
  customElements.define('bm-product-story', ProductStory);
}
